module.exports = __webpack_public_path__ + "static/media/Rectangle Copy.ec74251d.png";